import { getMediaFullUrl } from '@/functions/getMediaFullUrl';
import { Link } from '@reach/router';
import * as React from 'react';
import { Container } from '../container/Container';
import { LocalToExternalVideoPlayer } from '../localToExternalVideoPlayer/LocalToExternalVideoPlayer';
import * as styles from './VideoTextSection.module.scss';
import { RootNode } from '@strapi/blocks-react-renderer/dist/BlocksRenderer';
import { StrapiTextRenderer } from '../strapiTextRenderer/StrapiTextRenderer';

export const VideoTextSection = ({
  title,
  imageUrl,
  videoUrl,
  vimeoUrl,
  description,
  CTAName,
  CTALink,
  className,
}: {
  title: string;
  imageUrl: string;
  videoUrl: string;
  vimeoUrl: string;
  CTAName: string;
  CTALink: string;
  description: RootNode[];
  className?: string;
}) => (
  <Container className={className}>
    <LocalToExternalVideoPlayer
      externalSrc={vimeoUrl}
      localSrc={getMediaFullUrl(videoUrl)}
      fallbackUrl={getMediaFullUrl(imageUrl)}
    />
    <VideoTextSection.TitleDesc title={title} description={description} CTAName={CTAName} CTALink={CTALink} />
  </Container>
);

VideoTextSection.TitleDesc = ({
  title,
  description,
  CTAName,
  CTALink,
}: {
  title: string;
  description: RootNode[];
  CTAName?: string;
  CTALink?: string;
}) => {
  console.log({ description });

  return (
    <div className={styles.videoTextSection__descWrapper}>
      <p className={styles.videoTextSection__title}>{title}</p>
      <div>
        <StrapiTextRenderer content={description} />
        {CTALink && (
          <>
            {CTALink.startsWith('http') ? (
              <a href={CTALink} className={styles.videoTextSection__ctaLink} target="_blank" rel="noopener noreferrer">
                {CTAName}
              </a>
            ) : (
              <Link to={CTALink} className={styles.videoTextSection__ctaLink}>
                {CTAName}
              </Link>
            )}
          </>
        )}
      </div>
    </div>
  );
};
